<template>
  <!-- copilot begin -->
  <div class="cost-table">
    <div v-if="costData.length > 0" class="table-section">
      <el-table :data="costData" :key="tableKey" border class="cost-data-table" row-key="key" :span-method="spanMethod"
        :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column prop="feeTypeName" label="交易类型" width="180" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.isSeparator" class="separator-title">境外卡成本表</span>
            <span v-else>{{ row.feeTypeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cardType" label="卡类型" width="100" align="center" />

        <el-table-column label="D+1手续费" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.isSeparator">-</template>
            <div v-else>
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.t1Detail))" :precision="precision" :step="0.01"
                  :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.t1Detail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.t1Detail, val)" />
                <span class="unit">%</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="D+1单笔收费封顶" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.isSeparator || row.isShowMaxFee !== 1 || row.cardType === '贷记卡'">-</template>
            <div v-else>
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.t1MaxDetail))" :precision="precision" :step="1"
                  :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.t1MaxDetail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.t1MaxDetail, val)" />
                <span class="unit">元</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="D+0手续费" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.isSeparator">-</template>
            <div v-else>
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.t0Detail))" :precision="precision" :step="0.01"
                  :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.t0Detail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.t0Detail, val)" />
                <span class="unit">%</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="D+0单笔收费封顶" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.isSeparator || row.isShowMaxFee !== 1 || row.cardType === '贷记卡'">-</template>
            <div v-else>
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.t0MaxDetail))" :precision="precision" :step="1"
                  :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.t0MaxDetail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.t0MaxDetail, val)" />
                <span class="unit">元</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="rateSwitch" label="D+0垫资费（比例值）" align="center" width="200">
          <template slot-scope="{ row }">
            <template v-if="row.isSeparator || row.isShowD0WithdrawFee !== 1 || row.rateSwitch !== 1">-</template>
            <div v-else>
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.d0RateDetail))" :precision="precision"
                  :step="0.01" :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.d0RateDetail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.d0RateDetail, val)" />
                <span class="unit">%</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="fixedSwitch" label="D+0垫资费（固定值）" align="center" width="200">
          <template slot-scope="{ row }">
            <template v-if="row.isSeparator || row.isShowD0WithdrawFee !== 1 || row.fixedSwitch !== 1">-</template>
            <div v-else>
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.d0FixedDetail))" :precision="precision"
                  :step="0.01" :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.d0FixedDetail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.d0FixedDetail, val)" />
                <span class="unit">元</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- copilot begin -->
    <div v-if="foreignCardRows.length > 0" class="table-section foreign-card-section">
      <div class="foreign-card-title">境外卡成本表</div>
      <el-table :data="foreignCardRows" :key="'foreign-' + tableKey" border class="cost-data-table" row-key="key"
        :span-method="foreignSpanMethod" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column prop="feeTypeName" label="交易类型" width="120" align="center" />
        <el-table-column label="借记卡费率" align="center">
          <el-table-column align="center" min-width="130">
            <template slot-scope="{ row }">
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.debitRateDetail))" :precision="precision"
                  :step="0.001" :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.debitRateDetail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.debitRateDetail, val)" />
                <span class="unit">%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="120">
            <template slot-scope="{ row }">
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.debitFixedDetail))" :precision="precision"
                  :step="0.01" :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.debitFixedDetail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.debitFixedDetail, val)" />
                <span class="unit">元</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="贷记卡费率" align="center">
          <el-table-column align="center" min-width="130">
            <template slot-scope="{ row }">
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.creditRateDetail))" :precision="precision"
                  :step="0.001" :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.creditRateDetail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.creditRateDetail, val)" />
                <span class="unit">%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="120">
            <template slot-scope="{ row }">
              <div class="value-with-unit">
                <el-input-number :value="ceilTo2(getCostFeeDetail(row.creditFixedDetail))" :precision="precision"
                  :step="0.01" :min="0" size="small" :controls="false" :disabled="isCostEdit === 0"
                  :class="['fee-input', isOutOfRange(row.creditFixedDetail) ? 'tip' : '']"
                  @change="val => onFieldChange(row.creditFixedDetail, val)" />
                <span class="unit">元</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- copilot end -->
  </div>
  <!-- copilot end -->
</template>

<script>
// copilot begin
export default {
  name: "CostTable",
  props: {
    // 政策成本数据
    policyData: {
      type: Object,
      required: true,
    },
    // 0-只读，1-可编辑
    isCostEdit: {
      type: Number,
      default: 0,
    },
    // 费率精度
    precision: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    rateSwitch() {
      return this.policyData.rateSwitch === 1;
    },
    fixedSwitch() {
      return this.policyData.fixedSwitch === 1;
    },
    domesticCardData() {
      return this.buildCardRows(this.policyData.domesticTransAgentCostDetailList || [], "domestic", this.policyData.fixedSwitch, this.policyData.rateSwitch);
    },
    // copilot begin
    costData() {
      return this.domesticCardData;
    },
    foreignCardRows() {
      const list = this.policyData.foreignCardTransAgentCostDetailList || [];
      if (list.length === 0) return [];

      const rows = list.map((item) => {
        const current = item.currentValue || {};
        const t1 = current.t1FeeDetail || {};
        const minT1 = (item.minValue || {}).t1FeeDetail || {};
        const maxT1 = (item.maxValue || {}).t1FeeDetail || {};

        return {
          key: `foreign-${item.feeType}`,
          feeType: item.feeType,
          feeTypeName: item.feeTypeName,
          debitRateDetail: {
            current: t1,
            min: minT1,
            max: maxT1,
            field: "feeDebit",
          },
          debitFixedDetail: {
            current: t1,
            min: minT1,
            max: maxT1,
            field: "feeDebitFixed",
          },
          creditRateDetail: {
            current: t1,
            min: minT1,
            max: maxT1,
            field: "feeCredit",
          },
          creditFixedDetail: {
            current: t1,
            min: minT1,
            max: maxT1,
            field: "feeCreditFixed",
          },
        };
      });

      return rows;
      // copilot end
    },
    tableKey() {
      return JSON.stringify(this.policyData);
    },
  },
  watch: {
    policyData: {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  methods: {
    /**
     * @param {Array}  list        - domesticTransAgentCostDetailList国内成本值实体 或 foreignCardTransAgentCostDetailList国外成本值实体
     * @param {string} groupSuffix - 'domestic' | 'foreign'，用于生成 groupKey / row key
     * @param {number} fixedSw     - fixedSwitch 是否展示固定值提现费 0-否 1-是
     * @param {number} rateSw      - rateSwitch 是否展示比例提现费 0-否 1-是
     */
    buildCardRows(list, groupSuffix, fixedSw, rateSw) {
      const rows = [];
      list.forEach((item) => {
        const current = item.currentValue || {};
        const t1 = current.t1FeeDetail || {};
        const t0 = current.t0FeeDetail || {};
        const minT1 = (item.minValue || {}).t1FeeDetail || {};
        const minT0 = (item.minValue || {}).t0FeeDetail || {};
        const maxT1 = (item.maxValue || {}).t1FeeDetail || {};
        const maxT0 = (item.maxValue || {}).t0FeeDetail || {};

        const base = {
          feeType: item.feeType,
          feeTypeName: item.feeTypeName,
          isShowMaxFee: item.isShowMaxFee,
          isShowD0WithdrawFee: item.isShowD0WithdrawFee,
          fixedSwitch: fixedSw,
          rateSwitch: rateSw,
        };

        const d0 = field => ({
          current: t0,
          min: minT0,
          max: maxT0,
          field,
        });

        if (item.isDivideDebitAndCredit === 1) {
          const groupKey = `${item.feeType}-${groupSuffix}`;
          rows.push(
            Object.assign({}, base, {
              key: `${item.feeType}-debit`,
              groupKey,
              isFirstInGroup: true,
              cardType: "借记卡",
              t1Detail: {
                current: t1,
                min: minT1,
                max: maxT1,
                field: "feeDebit",
              },
              t1MaxDetail: {
                current: t1,
                min: minT1,
                max: maxT1,
                field: "feeDebitMax",
              },
              t0Detail: {
                current: t0,
                min: minT0,
                max: maxT0,
                field: "feeDebit",
              },
              t0MaxDetail: {
                current: t0,
                min: minT0,
                max: maxT0,
                field: "feeDebitMax",
              },
              d0RateDetail: d0("withdrawDebitRate"),
              d0FixedDetail: d0("withdrawDebitFixed"),
            }),
          );
          rows.push(
            Object.assign({}, base, {
              key: `${item.feeType}-credit`,
              groupKey,
              isFirstInGroup: false,
              cardType: "贷记卡",
              t1Detail: {
                current: t1,
                min: minT1,
                max: maxT1,
                field: "feeCredit",
              },
              t1MaxDetail: {
                current: t1,
                min: minT1,
                max: maxT1,
                field: "feeDebitMax",
              },
              t0Detail: {
                current: t0,
                min: minT0,
                max: maxT0,
                field: "feeCredit",
              },
              t0MaxDetail: {
                current: t0,
                min: minT0,
                max: maxT0,
                field: "feeDebitMax",
              },
              d0RateDetail: d0("withdrawCreditRate"),
              d0FixedDetail: d0("withdrawCreditFixed"),
            }),
          );
        } else {
          rows.push(
            Object.assign({}, base, {
              key: `${item.feeType}-all`,
              groupKey: `${item.feeType}-${groupSuffix}-single`,
              isFirstInGroup: true,
              cardType: "-",
              t1Detail: {
                current: t1,
                min: minT1,
                max: maxT1,
                field: "fee",
              },
              t1MaxDetail: {
                current: t1,
                min: minT1,
                max: maxT1,
                field: "feeDebitMax",
              },
              t0Detail: {
                current: t0,
                min: minT0,
                max: maxT0,
                field: "fee",
              },
              t0MaxDetail: {
                current: t0,
                min: minT0,
                max: maxT0,
                field: "feeDebitMax",
              },
              d0RateDetail: d0("withdrawDebitRate"),
              d0FixedDetail: d0("withdrawDebitFixed"),
            }),
          );
        }
      });

      return rows;
    },
    // 商户政策成本相关费率，统一向上取整保留两位小数
    // 代理商/机构政策成本相关费率，统一向上取整保留三位小数
    ceilTo2(value) {
      if (value === null || value === undefined || value === "") return null;
      const num = Number(value);
      if (Number.isNaN(num)) return null;
      const precision = this.precision;
      const factor = 10 ** precision;
      const scaled = num * factor;
      const scaledStable = Number(scaled.toFixed(14));
      return Math.ceil(scaledStable) / factor;
    },
    formatValue(value, unit) {
      if (value === null || value === undefined || value === "") return "-";
      const num = this.ceilTo2(value);
      return num === null ? "-" : `${num.toFixed(this.precision)}${unit}`;
    },
    // 当前值是否超出 [min, max] 区间
    isOutOfRange(costFeeDetail) {
      if (!costFeeDetail) return false;
      const val = this.getCostFeeDetail(costFeeDetail);
      if (val === null || val === undefined || val === "") return false;
      const min = this.getCostFeeDetail(costFeeDetail, "min");
      const max = this.getCostFeeDetail(costFeeDetail, "max");
      if ((min == null || min === "") && (max == null || max === "")) return false;
      const num = Number(val);
      const minNum = min == null || min === "" ? -Infinity : Number(min);
      const maxNum = max == null || max === "" ? Infinity : Number(max);
      return num < minNum || num > maxNum;
    },
    onFieldChange(costFeeDetail, val) {
      if (!costFeeDetail || !costFeeDetail.current || !costFeeDetail.field) return;
      costFeeDetail.current[costFeeDetail.field] = val === null || val === undefined ? null : String(val);
    },
    // 统一从 cost 中取值（type: 'current' | 'min' | 'max'，默认 'current'）
    getCostFeeDetail(costFeeDetail, type = "current") {
      if (!costFeeDetail || !costFeeDetail[type] || !costFeeDetail.field) return null;
      return costFeeDetail[type][costFeeDetail.field];
    },
    spanMethod({ row, column }) {
      if (column.property === "feeTypeName") {
        if (row.groupKey && !row.isFirstInGroup) return { rowspan: 0, colspan: 0 };
        if (row.groupKey && row.isFirstInGroup) {
          return row.groupKey.endsWith("-single") ? { rowspan: 1, colspan: 1 } : { rowspan: 2, colspan: 1 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },
    foreignSpanMethod({ row, columnIndex }) {
      return { rowspan: 1, colspan: 1 };
    },
    validateAll() {
      const errs = [];
      const reported = new Set();
      // copilot begin
      for (const row of this.costData) {
        const typeName = row.feeTypeName;
        const fields = [
          { wrap: row.t1Detail },
          { wrap: row.t1MaxDetail, skip: row.isShowMaxFee !== 1 },
          { wrap: row.t0Detail },
          { wrap: row.t0MaxDetail, skip: row.isShowMaxFee !== 1 },
          {
            wrap: row.d0RateDetail,
            skip: !(row.isShowD0WithdrawFee === 1 && row.rateSwitch === 1),
          },
          {
            wrap: row.d0FixedDetail,
            skip: !(row.isShowD0WithdrawFee === 1 && row.fixedSwitch === 1),
          },
        ];

        for (const { wrap, skip } of fields) {
          if (!skip && wrap) {
            if (this.isOutOfRange(wrap) && !reported.has(typeName)) {
              errs.push(`${typeName}费率存在倒挂，请重新修改`);
              reported.add(typeName);
            }
          }
        }
      }

      for (const row of this.foreignCardRows) {
        const typeName = row.feeTypeName;
        const fields = [{ wrap: row.debitRateDetail }, { wrap: row.debitFixedDetail }, { wrap: row.creditRateDetail }, { wrap: row.creditFixedDetail }];

        for (const { wrap } of fields) {
          if (wrap) {
            if (this.isOutOfRange(wrap) && !reported.has(typeName)) {
              errs.push(`${typeName}费率存在倒挂，请重新修改`);
              reported.add(typeName);
            }
          }
        }
      }
      // copilot end
      return errs;
    },
  },
};
// copilot end
</script>

<style scoped lang="scss">
.cost-table {
  .table-section {
    //margin-bottom: 30px;

    .table-title {
      margin: 16px 0 12px;
      font-size: 16px;
      font-weight: bold;
      color: #303133;
    }
  }

  .foreign-card-section {
    .foreign-card-title {
      padding: 12px 0;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      // background-color: #f5f7fa;
      border: 1px solid #ebeef5;
      border-top: none;
      border-bottom: none;
    }

    /deep/ .el-table__header {
      tr:nth-child(2) {
        display: none;
      }
    }
  }

  .cost-data-table {
    .value-with-unit {
      display: inline-flex;
      gap: 4px;
      align-items: center;
      justify-content: center;
    }

    .unit {
      font-size: 12px;
      color: #909399;
    }

    .range-text {
      margin-top: 4px;
      font-size: 12px;
      color: #909399;
    }

    .separator-title {
      color: #303133;
    }

    /deep/ .fee-input {
      width: 80px;
      margin: 0 2px;

      .el-input__inner {
        text-align: center;
      }
    }

    /deep/ .fee-input.tip .el-input__inner {
      color: red !important;
      border-color: red !important;
    }

    /deep/ .el-table__cell {
      padding: 12px 8px;
    }
  }
}
</style>
